const dataRoadMap = [
    {
        time: 'Understanding the scope',
        title: 'WHAT ARE THE DELIVERABLES',
        desc: 'First thing I to do is understad what my clients want, who is the target audience, and what are the results that need to be acheived.  What do they have in mind.',
        class: 'left'
    },
    {
        time: 'Collect the prerequisits',
        title: 'CAPTURE, COLLECT, PLAN, DESIGN, BRAINSTORM, IDEATE',
        desc: 'Depending on the deliverable at this stage I am collecting the parts, capturing the moments, or designing something.',
        class: 'right mt-223'
    },
    {
        time: 'Creative process where ideas come to life',
        title: 'THIS WHEN THE MAKING IS DONE, THIS IS WHEN THE MAGIC HAPPENS',
        desc: 'Creative process is when the things are made, edited , and refined.  Sometimes it is hard to explain but this is when I get to delight and inspire.',
        class: 'left mt--23'
    },
    {
        time: 'Final inputs and Delivery',
        title: 'FINISHING TOUCHES AND FINAL DELIVERY',
        desc: 'After careful review and approval, the final format is rendered and delived according to use case and audience type.',
        class: 'right mt-200'
    },
]

export default dataRoadMap;